import * as React from "react";
import { connect } from "react-redux";
import ItemMaster from "../../screens/ItemMaster";

import {
  fetchItemMaster,
  fetchBrand,
  fetchUnit,
  fetchMedicalType,
  AddItemMaster,
  ItemMasterSlectedPage,
  ItemMasterDelete,
  EditItemmaster,
  ItemMasterInActive,
  fetchAllbrands,
} from "./action";
class ItemMasterContainer extends React.Component<Props, State> {
  render() {
    return (
      <ItemMaster
        fetchItemMaster={this.props.fetchItemMaster}
        ItemMasterDtlsList={this.props.ItemMasterDtlsList}
        ItemMasterDtlsCount={this.props.ItemMasterDtlsCount}
        fetchBrand={this.props.fetchBrand}
        BrandList={this.props.BrandList}
        fetchUnit={this.props.fetchUnit}
        UnitList={this.props.UnitList}
        fetchMedicalType={this.props.fetchMedicalType}
        MedicalTypeList={this.props.MedicalTypeList}
        AddItemMaster={this.props.AddItemMaster}
        ItemMasterSlectedPage={this.props.ItemMasterSlectedPage}
        ItemMasterDelete={this.props.ItemMasterDelete}
        EditItemmaster={this.props.EditItemmaster}
        ItemMasterInActive={this.props.ItemMasterInActive}
        fetchAllbrands={this.props.fetchAllbrands}
        allBrands={this.props.allBrands}
      />
    );
  }
}
function bindAction(dispatch) {
  return {
    fetchItemMaster: (value) => {
      dispatch(fetchItemMaster(value));
    },
    fetchBrand: (value) => {
      dispatch(fetchBrand(value));
    },
    fetchUnit: () => {
      dispatch(fetchUnit());
    },
    fetchMedicalType: () => {
      dispatch(fetchMedicalType());
    },
    AddItemMaster: (value) => {
      dispatch(AddItemMaster(value));
    },
    ItemMasterSlectedPage: (value) => {
      dispatch(ItemMasterSlectedPage(value));
    },
    ItemMasterDelete: (value) => {
      dispatch(ItemMasterDelete(value));
    },
    EditItemmaster: (value) => {
      dispatch(EditItemmaster(value));
    },
    ItemMasterInActive: (value) => {
      dispatch(ItemMasterInActive(value));
    },
    fetchAllbrands: () => {
      dispatch(fetchAllbrands());
    },
  };
}

function mapStateToProps(state) {
  return {
    ItemMasterDtlsList: state.ItemMasterReducer.ItemMasterDtlsList,
    ItemMasterDtlsCount: state.ItemMasterReducer.ItemMasterDtlsCount,
    BrandList: state.ItemMasterReducer.BrandList,
    UnitList: state.ItemMasterReducer.UnitList,
    MedicalTypeList: state.ItemMasterReducer.MedicalTypeList,
    allBrands: state.ItemMasterReducer.allBrands,
  };
}

export default connect(mapStateToProps, bindAction)(ItemMasterContainer);
